import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import phone from "../../Assests/phone.png";
import blue from "../../Assests/blue.png";
import google from "../../Assests/googleplay.png";
import apple from "../../Assests/apple.png";
const Phone = () => {
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: { xs: "auto", md: "100vh" },
        width: "100%",
        py: { xs: 8, md: 0 },
        px: { xs: 3, sm: 4, md: 6 },
      }}
    >
      {/* Background Shape - Full Width */}
      <Box
        component="img"
        src={blue}
        alt="Background Shape"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Content Wrapper */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: { xs: "column", md: "row" },
          width: "100%",
          maxWidth: "1200px",
        }}
      >
        {/* Left: Phone Image */}
        <Box
          component="img"
          src={phone}
          alt="Phone"
          sx={{
            width: { xs: "70%", sm: "50%", md: "35%" },
            maxWidth: { xs: "300px", sm: "none" },
            transform: { xs: "none", md: "rotate(-10deg)" },
            mb: { xs: 6, md: 0 },
            zIndex: 2,
          }}
        />

        {/* Right: Text + Buttons */}
        <Box
          sx={{
            color: "#fff",
            textAlign: { xs: "center", md: "left" },
            width: { xs: "100%", md: "55%" },
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: '1.75rem', sm: '2.125rem' },
              lineHeight: { xs: 1.2, sm: 1.3 },
            }}
          >
            Simplify your payments <br /> with Zutopay.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              opacity: 0.9,
              mb: 4,
              fontSize: { xs: '0.9rem', sm: '1rem' },
              px: { xs: 1, sm: 0 },
            }}
          >
            Track your transactions, manage your wallet, and pay securely —
            anytime, anywhere.
          </Typography>

          {/* Buttons */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 2, sm: 2 }}
            justifyContent={{ xs: "center", md: "flex-start" }}
            alignItems="center"
            width="100%"
            maxWidth={{ xs: '300px', sm: '100%' }}
            mx={{ xs: 'auto', sm: 0 }}
            flexWrap="wrap"
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#fff",
                color: "#000",
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "12px",
                px: 2,
                py: 1,
                width: { xs: '100%', sm: 'auto' },
                minWidth: { xs: '100%', sm: '180px' },
                height: 'auto',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 2,
                "&:hover": { 
                  backgroundColor: "#f5f5f5",
                },
              }}
              component="a"
              href="#"
              aria-label="Get it on Google Play"
            >
              <Box component="img" src={google} alt="Google Play" sx={{ height: '40px', width: 'auto' }} />
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1 }}>
                <Typography variant="caption" sx={{ fontSize: '10px', lineHeight: 1.2, color: 'text.secondary' }}>Get it on</Typography>
                <Typography variant="subtitle2" sx={{ fontSize: '14px', lineHeight: 1.2, fontWeight: 500 }}>Google Play</Typography>
              </Box>
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#fff",
                color: "#000",
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "12px",
                px: 2,
                py: 1,
                width: { xs: '100%', sm: 'auto' },
                minWidth: { xs: '100%', sm: '180px' },
                height: 'auto',
                "&:hover": { 
                  backgroundColor: "#f5f5f5",
                },
              }}
              component="a"
              href="#"
              aria-label="Download on the App Store"
            >
              <Box component="img" src={apple} alt="App Store" sx={{ height: '40px', width: 'auto' }} />
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1 }}>
                <Typography variant="caption" sx={{ fontSize: '10px', lineHeight: 1.2, color: 'text.secondary' }}>Download on the</Typography>
                <Typography variant="subtitle2" sx={{ fontSize: '14px', lineHeight: 1.2, fontWeight: 500 }}>App Store</Typography>
              </Box>
            </Button>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default Phone;
